import { useCallback } from 'react'
import { IntegrationType } from '../server/mpsklad_core/Entity/IntegrationType'
import { useRouteMatch } from 'react-router-dom'
import { useStore } from './storeHook'
import { appRoutes, IntegrationHookParams } from '../common/appRoutes'
import { isIntegrationType } from '../types/integrationTypeUtils'
import { exact } from '../common/tsUtils'
import { HomeTab } from '../components/HomeTabTitle'
import { makeOzonAccountName, makeWbAccountName, makeYandexMarketAccountName } from '../common/accountUtils'
import { MoySkladAccountModel } from '../server/mpsklad_core/Models/MoySkladAccountModel'

type HomeTabExtended = HomeTab | {
  id: number
  title: string
  integrationType: IntegrationType.MoySklad
  ozonAccount?: undefined
  wbAccount?: undefined
  yandexMarketAccount?: undefined
  moySkladAccount: MoySkladAccountModel
}

export const useAccountsTabs = (ignoreIntegration?: boolean): HomeTabExtended[] => {
  const store = useStore()
  const routeMatch = useRouteMatch<IntegrationHookParams>(appRoutes.Store.template)

  const {
    syncStore: {ozonAccounts, wbAccounts, yandexMarketAccounts, moySkladAccount},
    allowedIntegrations
  } = store

  const integration = !ignoreIntegration ? routeMatch?.params?.integration : undefined

  const getTabs = useCallback(() => {
    const result: HomeTabExtended[] = []

    if (allowedIntegrations[IntegrationType.Ozon] &&
        (integration === 'Ozon' ||
         integration === 'MoySklad' ||
         !isIntegrationType(integration))) {
      result.push(
        ...ozonAccounts.map(ozonAccount => exact<HomeTabExtended>({
          ozonAccount,
          id: ozonAccount.id,
          title: makeOzonAccountName(ozonAccount),
          integrationType: IntegrationType.Ozon
        }))
      )
    }

    if (allowedIntegrations[IntegrationType.Wildberries] &&
        (integration === 'Wildberries' ||
         integration === 'MoySklad' ||
         !isIntegrationType(integration))) {
      result.push(
        ...wbAccounts.map(wbAccount => exact<HomeTabExtended>({
          wbAccount,
          id: wbAccount.id,
          title: makeWbAccountName(wbAccount),
          integrationType: IntegrationType.Wildberries
        }))
      )
    }

    if (allowedIntegrations[IntegrationType.YandexMarket] &&
        (integration === 'YandexMarket' ||
         integration === 'MoySklad' ||
         !isIntegrationType(integration))) {
      result.push(
        ...yandexMarketAccounts.map(yandexMarketAccount => exact<HomeTabExtended>({
          yandexMarketAccount,
          id: yandexMarketAccount.id,
          title: makeYandexMarketAccountName(yandexMarketAccount),
          integrationType: IntegrationType.YandexMarket
        }))
      )
    }

    if (allowedIntegrations[IntegrationType.MoySklad] &&
        (integration === 'MoySklad' || !isIntegrationType(integration))) {
      if (moySkladAccount) {
        result.push(exact<HomeTabExtended>({
          id: moySkladAccount.id,
          title: 'Мой Склад',
          integrationType: IntegrationType.MoySklad,
          moySkladAccount
        }))
      }
    }

    return result
  }, [allowedIntegrations, integration, ozonAccounts, wbAccounts, yandexMarketAccounts, moySkladAccount])

  return getTabs()
}
